export default __webpack_public_path__ + "static/media/pre-arrow.eb22a79e.svg";